import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {Field, getFormValues, reduxForm} from 'redux-form';

import axios from 'axios';
import parse from 'html-react-parser';

import {Box, CircularProgress} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import {API_CODE, isChudenNwContract} from '../../../common/common';
import {authOperations} from '../../../reducks/auth';
import {commonOperations} from '../../../reducks/common';
import PositiveButton from '../../atoms/Buttons/PositiveButton.js';
import * as validateRule from '../../validateRule';
import LoginCommon, {commonStyles, renderTextField} from './loginCommon.js';

import Conf from '../../../config/config.js';

// 利用可能時間
const availableTime = Conf.availableTime;

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      loading: false,
    };
  }

  componentDidMount() {
    this.getAwsMessage();
  }

  /**
   * メッセージの取得。
   */
  getAwsMessage = async () => {
    this.setState({loading: true});

    try {
      const axiosInstance = axios.create();
      const ret = await axiosInstance.post(Conf.API_URL + 'AwsMessage/getAwsMessage');
      const responseBody = ret.data.body;

      // メッセージ取得エラーの場合は例外を投げてcatchへ遷移
      if (responseBody.errorCode && responseBody.errorCode !== '00000') {
        throw new Error('API実行時エラー');
      }

      // メッセージをstateに設定
      const messages = responseBody.data || [];
      if (messages.length === 0) {
        // メッセージがない場合は文字列を設定
        this.setState({message: '現在、掲載中のお知らせはありません。'});
      } else {
        // メッセージがある場合は配列を設定
        this.setState({message: messages});
      }
    } catch (err) {
      // エラー時には「現在、掲載中のお知らせはありません。」を表示
      console.error('AWSメッセージの取得に失敗しました:', err);
      this.setState({message: 'メッセージの取得に失敗しました。'});
    } finally {
      this.setState({loading: false});
    }
  }

  doLogin = async () => {
    console.log('#######');
    const {
      doShowMessage,
      getLoginInfo,
      history,
      loginAction,
      setIsTermsAccepted,
      setHasJuyoZiko,
      setIsKirikaeMae,
      signOut,
    } = this.props;

    try {
      const result = await loginAction();
      console.log('結果：' + result);
      if (result === 'OK') {
        // ログイン関連情報一括取得
        const loginInfo = await getLoginInfo();

        // エラーコードが指定されていて、成功ではない場合
        if (loginInfo.errorCode && (loginInfo.errorCode != API_CODE.SUCCESS)) {
          const errorData = loginInfo.data;
          switch (loginInfo.errorCode) {
            case API_CODE.ERROR_UNAVAILABLE_TIME:
              // 利用時間外の場合
              doShowMessage({
                message: {
                  id: 'CE0199',
                  values: [errorData.start, errorData.end],
                },
                action: () => {
                  signOut();
                },
              });
              break;

            default:
              // それ以外の場合はシステムエラー
              doShowMessage({
                message: 'CS0001',
                action: () => {
                  signOut();
                },
              });
              break;
          }

          return;
        }

        // ログイン日時がシステム切替日時以降なのか判別するフラグを設定する
        const _generalPurpose =
          loginInfo.generalPurpose != null ? loginInfo.generalPurpose : [];
        const listKirikaeDtList =
          _generalPurpose.filter(
              (data) => data.CategoryType__c == 'KirikaeDt' && data.Code__c == '1');
        const listKirikaeDt1 = listKirikaeDtList.length > 0 ?
          listKirikaeDtList[0].ValueDateTime__c : null;
        setIsKirikaeMae(loginInfo.systemDate, listKirikaeDt1);

        let _isTermsAccepted = loginInfo.isTermsAccepted;
        let _hasJuyoZiko = loginInfo.hasJuyoZiko;

        // 強制遷移を行うユーザかどうか判定する
        if (!this.checkForceTransition(loginInfo.currentUser)) {
          // メニューに遷移するようにフラグをたてる
          _isTermsAccepted = true;
          _hasJuyoZiko = false;
        }
        setIsTermsAccepted(_isTermsAccepted);
        setHasJuyoZiko(_hasJuyoZiko);

        // 約款が承諾されていない場合、重要事項説明画面へ遷移
        if (!_isTermsAccepted) {
          history.push('/importantSubjects', null, 'CLEAR');
          return;
        }

        // 未確認の重要事項確認が存在する場合、重要事項確認画面へ遷移
        if (_hasJuyoZiko) {
          history.push('/Other/ContactZiko/JuyoZiko/List', null, 'CLEAR');
          return;
        }

        // メニュー画面へ遷移
        history.push('/menu');
      } else if (result === 'REDIRECT_NEW_PASSWORD') {
        // 仮パスワードログインのため、パスワード変更画面へリダイレクト
        const dialog = {
          message: 'CI0123',
          action: () => {
            history.push('/changePassword');
          },
        };
        doShowMessage(dialog);
      } else if (result === 'NO_SF_USER') {
        // 本登録が完了していない
        const dialog = {
          message: 'CE0114',
        };
        doShowMessage(dialog);
      } else if (result === 'RESET_REQUIRE') {
        const dialog = {
          message: 'CI0126',
        };
        doShowMessage(dialog);
      } else if (result === 'NO_LOGIN') {
        const dialog = {
          message: 'CE0115',
        };
        doShowMessage(dialog);
      } else {
        const dialog = {
          message: 'CS0001',
        };
        doShowMessage(dialog);
      }
    } catch (err) {
      console.log('エラー');
      console.error(err);
      const dialog = {
        message: 'CS0001',
      };
      doShowMessage(dialog);
    }
  };

  /**
   * 画面の強制遷移を行うかどうかの判定。
   *
   * 重要事項説明が未承諾の場合は重要事項説明画面、
   * 未確認の重要事項が登録されている場合は重要事項確認画面へ
   * 遷移を行うが、以下いずれかに該当する場合は強制遷移を行わないと判定する
   * ・ログインユーザの契約区分が「中国電力ネットワーク契約」
   * ・ログインユーザが代行者
   *
   * @param {object} userInfo ユーザ情報
   * @return {boolean} 強制遷移を行う場合true
   */
  checkForceTransition = (userInfo) => {
    // 中国電力ネットワーク契約のユーザは強制遷移を行わない
    if (isChudenNwContract(userInfo)) {
      return false;
    }

    // 代行者の場合は強制遷移を行わない
    if (userInfo.RecordType.DeveloperName == 'Daikosya') {
      return false;
    }

    return true;
  }

  doPasswordReset = () => {
    this.props.history.push('/resetPassword');
  };

  moveToDocumentFormatList = () => {
    this.props.history.push('/templateList');
  };

  createMessageElements = (messages, classes) => {
    // 文字列の場合（手動で設定したエラーメッセージ等）
    if (typeof messages === 'string') {
      return (
        <div className={classes.messageRow}>
          <Typography style={{flex: 1, minWidth: 0, wordBreak: 'break-word'}}>{parse(messages)}</Typography>
        </div>
      );
    }

    // 配列でない場合はnullを返す
    if (!messages || !Array.isArray(messages) || messages.length === 0) {
      return null;
    }

    const elements = [];

    for (const messageItem of messages) {
      const date = messageItem.AwsMessageDate__c;
      const message = messageItem.AwsMessage__c;

      // メッセージ本文が存在しない場合はスキップ
      if (!message) {
        continue;
      }

      if (date) {
        // 日付が設定されている場合
        // ハイフン区切りをスラッシュ区切りに置換
        const dateStr = date.replace(/-/g, '/');

        elements.push(
            <div key={`msg-${messageItem.Id || date}-${elements.length}`}
              className={classes.messageRow}>
              <Typography className={classes.messageDate}>{dateStr}</Typography>
              <Typography style={{flex: 1, minWidth: 0, wordBreak: 'break-word'}}>{parse(message)}</Typography>
            </div>,
        );
      } else {
        // 日付が設定されていない場合
        elements.push(
            <div key={`msg-${messageItem.Id || elements.length}`}
              className={classes.messageRow}>
              <Typography style={{flex: 1, minWidth: 0, wordBreak: 'break-word'}}>{parse(message)}</Typography>
            </div>,
        );
      }
    }

    return elements.length > 0 ? elements : null;
  }

  render() {
    const {classes, handleSubmit} = this.props;

    return (
      <LoginCommon>
        <Grid container>
          <Grid item xs={12}>
            <Field
              name="username"
              label="ユーザーID"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="username"
              type="text"
              validate={[
                validateRule.required,
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              name="password"
              label="パスワード"
              type="password"
              className={classes.textField}
              required={true}
              margin="normal"
              variant="outlined"
              component={renderTextField}
              autoComplete="current-password"
              validate={[
                validateRule.required,
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <PositiveButton
              onClick={handleSubmit(this.doLogin)}
              variant="contained"
              className={classes.button}
              size="large"
            >
              <span>ログイン</span>
            </PositiveButton>
          </Grid>
          {/* <Grid item xs={12}>
            <Button
              onClick={this.moveToDocumentFormatList}
              className={classes.button}>
              <u>申込関連書類書式一覧</u>
            </Button>
          </Grid> */}
          <Grid item xs={12}>
            <Button
              onClick={this.doPasswordReset}
              className={classes.button}>
              <u>パスワードを忘れた方</u>
            </Button>
          </Grid>
          <Grid item xs={12} align="center">
            <div className={classes.noticeArea}>
              <Typography display="inline">
                お知らせ
              </Typography>
              {(this.state.message != null && !this.state.loading) &&
                  <div className={classes.messageArea}>
                    {this.createMessageElements(this.state.message, classes)}
                  </div>
              }
              {this.state.loading &&
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <CircularProgress size={48}/>
                </Box>
              }
            </div>
          </Grid>

          {/* メンテナンス情報等表示用DIV */}
          {/*
          <div className={classes.noticeArea}>
            <div className={classes.noticeTitle}>お知らせ</div>
            <span className={classes.noticeRed} style={{marginTop: '8px'}}>
              高梁NWC・岩国NWC・萩NWC担当区域の留意事項<br/>
            </span>
            2026年2月1日(日)以降は、中国電力ネットワークの担当区域の見直しにより、
            高梁は倉敷に、岩国は周南に、また萩は山口に統合されます。<br/>
            そのため、高梁、岩国または萩の仕掛り中の件名は、
            それぞれ倉敷、周南または山口へデータ移行されるためご注意ください。<br/>
            また、電柱選択時の事業所として、高梁、岩国または萩を選択していた申込については、それぞれ倉敷、周南または山口を選択してください。
          </div>
          */}

          {/* お知らせ表示用DIV */}
          {/*
          <div className={classes.helpDesk}>
            お知らせ文言<br />
          </div>
          */}

          {availableTime &&
          <div className={classes.availableTimeArea}>
            <span className={classes.availableTime}>
            Yupol(ユーポル)稼働時間 : {availableTime.start} 〜 {availableTime.end}
            </span>
            <span className={classes.maintenanceExclusion}>
              ※システムメンテナンス時を除く
            </span>
          </div>
          }

          <span className={classes.copyright}>
            Copyright © Chugoku Electric Power Transmission & Distribution Co.,Inc. All rights reserved.
          </span>
        </Grid>
      </LoginCommon>
    );
  }
}

const FORM_NAME = 'Login';

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  doShowMessage: PropTypes.func,
  handleSubmit: PropTypes.func,
  history: PropTypes.object,
  loginAction: PropTypes.func,
  getLoginInfo: PropTypes.func,
  setIsTermsAccepted: PropTypes.func,
  setHasJuyoZiko: PropTypes.func,
  setIsKirikaeMae: PropTypes.func,
  signOut: PropTypes.func,
};

const mapDispatchToProps = {
  getLoginInfo: commonOperations.doGetLoginInfo,
  setIsTermsAccepted: commonOperations.doSetIsTermsAccepted,
  setHasJuyoZiko: commonOperations.doSetHasJuyoZiko,
  setIsKirikaeMae: commonOperations.doSetIsKirikaeMae,
  signOut: authOperations.doSignOutOperation,
};

const mapStateToProps = (state) => ({
});

Login = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Login));
export default withStyles(commonStyles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Login),
);
